import React, { useEffect } from "react";
import { useCrud } from "../common/crudCard/useCrud";
import { CrudLayout } from "../common/crudCard/crudLayout";
import { useHistory } from "react-router-dom";
import { getEstados, checkDeleteEstado, deleteEstado } from "../../services/estadosService";
import { cleanString } from "../utils/cleanString";
import EstadosTable from "./estadosTable";

export default function Estados(props) {
  const { onLoading, onDoneLoading } = props;

  const title = "Estados";

  const breadcrumbs = [
    {
      title: "Inicio",
      link: "/main",
    },
    {
      title: "Estados",
    },
  ];

  const history = useHistory();

  const filterData = (records, query) => {
    return records.filter((m) => cleanString(m.descripcion).includes(cleanString(query)));
  };

  const checkBeforeDelete = async (id) => {
    const canDelete = await checkDeleteEstado(id);
    return canDelete;
  };

  const onDelete = async (id) => {
    try {
      await deleteEstado(id);
    } catch (ex) {
      throw ex;
    }
  };

  const crud = useCrud({
    defaultPath: "/estados",
    defaultSortColumn: { path: "descripcion", order: "asc" },
    checkBeforeDelete,
    filterData,
    onDelete,
    onLoading,
    onDoneLoading,
  });

  const fetchData = async () => {
    onLoading();
    const registros = await getEstados();
    onDoneLoading();
    if (registros === "NETWORK ERROR") return history.push("/noconnection");
    crud.updateAllRecords(registros);
  };

  const handleSearch = (query) => {
    crud.setSearchQuery(query);
    crud.setCurrentPage(1);
  };

  useEffect(() => {
    if (!crud.mounted) {
      fetchData();
      crud.setMounted(true);
    }
  }, []);

  return (
    <CrudLayout
      title={title}
      breadcrumbs={breadcrumbs}
      newLink="/estados/nuevo"
      permisos={crud.permisos}
      onChangeSearch={handleSearch}
      onPageChange={crud.handlePageChange}
      filterData={filterData}
      totalCount={crud.totalCount}
      pageSize={crud.pageSize}
      currentPage={crud.currentPage}
    >
      <EstadosTable
        permisos={crud.permisos}
        records={crud.records}
        onDelete={(id) => crud.handleDelete(id)}
        onEdit={(id) => crud.handleEdit(id)}
        onSort={(sortColumn) => crud.handleSort(sortColumn)}
        onView={(id) => crud.handleView(id)}
        sortColumn={crud.sortColumn}
      />
    </CrudLayout>
  );
}
